export var DEFAULT_LIMIT = 20;
export var DEFAULT_PAGE = 1;
export var TABLE_PAGE_SIZE_OPTIONS = [10, 20, 50];
